import { AlertCircle, CheckCircle2, Clock, Loader2 } from "lucide-react";
import { Badge } from "../ui/badge";
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "../ui/tooltip";

interface StatusBadgeProps {
	status: "pending" | "processing" | "completed" | "failed";
	errorMessage?: string | null;
}

export function StatusBadge({ status, errorMessage }: StatusBadgeProps) {
	const variants: Record<
		string,
		{
			variant: "default" | "secondary" | "destructive" | "outline";
			icon: React.ReactNode;
			label: string;
		}
	> = {
		pending: {
			variant: "secondary",
			icon: <Clock className="h-3 w-3" />,
			label: "Pending",
		},
		processing: {
			variant: "default",
			icon: <Loader2 className="h-3 w-3 animate-spin" />,
			label: "Processing",
		},
		completed: {
			variant: "default",
			icon: <CheckCircle2 className="h-3 w-3" />,
			label: "Completed",
		},
		failed: {
			variant: "destructive",
			icon: <AlertCircle className="h-3 w-3" />,
			label: "Failed",
		},
	};

	const config = variants[status];

	if (status === "failed" && errorMessage) {
		return (
			<TooltipProvider>
				<Tooltip>
					<TooltipTrigger asChild>
						<Badge variant={config.variant} className="flex items-center gap-1">
							{config.icon}
							{config.label}
						</Badge>
					</TooltipTrigger>
					<TooltipContent>
						<p className="max-w-xs">{errorMessage}</p>
					</TooltipContent>
				</Tooltip>
			</TooltipProvider>
		);
	}

	return (
		<Badge variant={config.variant} className="flex items-center gap-1">
			{config.icon}
			{config.label}
		</Badge>
	);
}
